import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Markdown from './modules/components/Markdown';
import Typography from './modules/components/Typography';
import terms from './modules/views/terms.md';
import Page from '../components/Page'

class Terms extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      terms: null
    }
  }

  componentDidMount() {
    fetch(terms).then((response) => response.text()).then((text) => {
      this.setState({ terms: text })
    })
  }

  render() {

    if (this.state.terms == null) {
      return null;
    }

    return (
      <Page history={this.props.history} isVerticalCenter={false}>
        <Container>
          <Box mt={7} mb={12}>
            <Typography variant="h4" gutterBottom marked="center" align="center">
              Terms & Conditions
            </Typography>
            <Markdown>{this.state.terms}</Markdown>
          </Box>
        </Container>
      </Page>
    );
  }
}

export default Terms;
